import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const useDateStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: 0,
    fontFamily: mixins.fontFamilyPlusSans
  },
  dateAndDaysSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
    borderRadius: 16,
    padding: 16,
    border: `1px solid ${mixins.greyColor}`
  },
  rowsWrapper: {
    display: 'flex',
    gap: 32,
    justifyContent: 'space-between'
  },
  descriptionText: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14,
    fontWeight: mixins.fontWeight600,
    lineHeight: '22px',
    color: mixins.color_text_primary,
    margin: '0px !important'
  },
  dateTimeRow: {
    display: 'flex',
    gap: 8,
    alignItems: 'flex-end'
  },
  dateFieldWrapper: {
    flex: 1,
    '& > div': {
      width: '100%'
    }
  },
  timeFieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  fieldLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14,
    fontWeight: mixins.fontWeight600,
    lineHeight: '22px',
    color: mixins.color_text_primary,
    marginBottom: '8px'
  },
  dateTimeInputRow: {
    display: 'flex',
    alignItems: 'center'
  },
  timeInput: {
    width: 156,
    height: 48,
    boxSizing: 'border-box',
    padding: 12,
    borderRadius: 4,
    border: `1px solid ${mixins.amethystColor}`,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight400,
    color: mixins.color_text_primary,
    backgroundColor: mixins.whiteFont,
    outline: 'none',
    '&:focus': {
      borderColor: mixins.amethystColor
    }
  },
  iconButton: {
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${mixins.greyColor}`,
    borderRadius: '8px',
    backgroundColor: mixins.whiteFont,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: mixins.quaternary
    }
  },
  questionText: {
    lineHeight: '22px',
    color: mixins.color_text_primary,
    margin: '0px !important',
    fontWeight: mixins.fontWeight600,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14
  },
  weeksWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  daysContainer: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    justifyContent: 'flex-start'
  },
  dayCheckbox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer',
    userSelect: 'none',
    minWidth: 64,
    padding: 12,
    borderRadius: 12,
    backgroundColor: mixins.feedBackColor
  },
  checkbox: {
    padding: 0, // Remove default padding
    maxHeight: 18,
    '& .MuiSvgIcon-root': {
      fontSize: 18, // Set icon size
      color: mixins.amethystColor
    }
  },
  checkmark: {
    color: mixins.whiteFont,
    fontSize: '16px',
    fontWeight: mixins.fontWeight700
  },
  dayLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize12,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px',
    color: mixins.color_text_primary
  },
  confirmButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '16px'
  },
  confirmButton: {
    padding: '12px 32px',
    borderRadius: '1000px',
    backgroundColor: mixins.amethystColor,
    color: mixins.whiteFont,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight600,
    lineHeight: '24px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: mixins.amethystColorV2
    },
    '&:disabled': {
      backgroundColor: mixins.mutedTextColor,
      cursor: 'not-allowed'
    }
  },
  footerText: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize14,
    fontWeight: mixins.fontWeight400,
    lineHeight: '22px',
    color: mixins.mutedTextColor,
    textAlign: 'center'
  },
  bulkEditDateTextField: {
    '& > div > div': {
      position: 'relative',
      width: 156,
      height: 48,
      boxSizing: 'border-box'
    }
  },
  bulkEditDescription: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight500,
    lineHeight: '24px',
    margin: 0
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  }
}));

export default useDateStyles;
